export interface NetworkStatusSnapshot {
  isOnline: boolean;
  connectionType: 'slow-2g' | '2g' | '3g' | '4g' | 'unknown';
  downlink?: number;
  rtt?: number;
  networkType?: string;
  saveData?: boolean;
  quality: 'good' | 'slow' | 'offline';
}

interface NetworkInformation extends EventTarget {
  effectiveType?: 'slow-2g' | '2g' | '3g' | '4g';
  downlink?: number;
  rtt?: number;
  type?: string;
  saveData?: boolean;
}

declare global {
  interface Navigator {
    connection?: NetworkInformation;
    mozConnection?: NetworkInformation;
    webkitConnection?: NetworkInformation;
  }
}

function getNetworkConnection(): NetworkInformation | undefined {
  return navigator.connection || navigator.mozConnection || navigator.webkitConnection;
}

function determineQuality(
  isOnline: boolean,
  connectionType: NetworkStatusSnapshot['connectionType'],
  rtt?: number,
): NetworkStatusSnapshot['quality'] {
  if (!isOnline) {
    return 'offline';
  }

  if (connectionType === 'slow-2g' || connectionType === '2g') {
    return 'slow';
  }

  if (rtt !== undefined && rtt > 500) {
    return 'slow';
  }

  return 'good';
}

export function getNetworkStatus(): NetworkStatusSnapshot {
  const isOnline = navigator.onLine;
  const connection = getNetworkConnection();

  const connectionType = connection?.effectiveType ?? 'unknown';
  const downlink = connection?.downlink;
  const rtt = connection?.rtt;
  const networkType = connection?.type;
  const saveData = connection?.saveData;

  const quality = determineQuality(isOnline, connectionType, rtt);

  return {
    isOnline,
    connectionType,
    downlink,
    rtt,
    networkType,
    saveData,
    quality,
  };
}
